import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Close } from '@material-ui/icons'
import { CleanButton, Label } from '../default'
import { Box, Grid, IconButton, Modal, Paper, Tooltip, withStyles } from '@material-ui/core'
import { connect, useDispatch } from 'react-redux'

import { Loader, Alert, PrimaryButton } from '../../components/default'
import { acUnblockCustomer, acBlockCustomer } from '../../class/actions'

function BlockModal({
    classes, open, onClose, onRefresh,
    currentCustomer, toggledBlock, errorToggleBlock, togglingBlock
}) {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const toggleBlock = isBlocked => {
        let action
        if (isBlocked) {
            action = () => acUnblockCustomer(currentCustomer.id)
        } else {
            action = () => acBlockCustomer(currentCustomer.id)
        }
        dispatch(action()).then(() => {
            onRefresh()
        })
            .catch(err => console.error(err))
    }

    return (
        <Modal open={open} onClose={onClose} disableAutoFocus style={{ outline: 0 }}>
            <Paper
                square={true}
                className={classes.root + ' ' + classes.modalDiv}
            >
                <Box display='flex' alignItems='center' justifyContent='space-between'>
                    <Label v='h6'>
                        {t('modals.block.title')}
                    </Label>
                    <Tooltip title={t('default.close')}>
                        <IconButton onClick={onClose}>
                            <Close />
                        </IconButton>
                    </Tooltip>
                </Box>

                <div>
                    <div>
                        {
                            <Label v='body1'>
                                {currentCustomer && !currentCustomer.isBlocked && `Você deseja bloquear o usuário ${currentCustomer.fullName} - ${currentCustomer.email}? Ao ser bloqueado, o usuário não irá conseguir utilizar a interface do 4KST Consulta.`}
                                {currentCustomer && currentCustomer.isBlocked && `Você deseja desbloquear o usuário ${currentCustomer.fullName} - ${currentCustomer.email}? Ao ser desbloqueado, o usuário voltará a ter acesso à interface do 4KST Consulta.`}
                            </Label>
                        }

                        {
                            errorToggleBlock && (
                                <Alert style={{ marginBottom: '15px' }} noMargin color="error" text={currentCustomer.isBlocked ? t('modals.unblock.error') : t('modals.block.error')} />
                            )
                        }
                    </div>
                    <div style={{ marginTop: '15px' }}>
                        <Grid container style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <CleanButton onClick={onClose} style={{ marginRight: '15px' }}>
                                {t('default.cancel')}
                            </CleanButton>
                            <PrimaryButton onClick={() => toggleBlock(currentCustomer.isBlocked)}>
                                {
                                    togglingBlock ? (
                                        <Loader />
                                    ) : (
                                        <div>
                                            {currentCustomer && !currentCustomer.isBlocked && t('modals.block.confirm')}
                                            {currentCustomer && currentCustomer.isBlocked && t('modals.unblock.confirm')}
                                        </div>
                                    )
                                }
                            </PrimaryButton>
                        </Grid>
                    </div>
                </div>
            </Paper>
        </Modal>
    )
}

BlockModal.propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    close: PropTypes.func
}

BlockModal.defaultProps = {
    open: false,
    onClose: () => true,
    close: () => true
}

const styles = theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        padding: theme.spacing(2),
    },
    modalDiv: {
        [theme.breakpoints.up('md')]: {
            width: '35%'
        },
        width: '100%',
        top: '10%',
        left: '50%',
        transform: 'translate(-50%, -10%)',
    }
})

const mapStateToProps = ({ ReducerCustomer }) => ({
    toggledBlock: ReducerCustomer.toggledBlock,
    errorToggleBlock: ReducerCustomer.errorToggleBlock,
    togglingBlock: ReducerCustomer.togglingBlock
})

export default connect(mapStateToProps)(withStyles(styles)(BlockModal))